import { render, staticRenderFns } from "./TaskChat.vue?vue&type=template&id=b83d5854&scoped=true&"
import script from "./TaskChat.vue?vue&type=script&lang=js&"
export * from "./TaskChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskChat.vue?vue&type=style&index=0&id=b83d5854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83d5854",
  null
  
)

export default component.exports